import React, { FC } from "react";
import { useLocation } from "react-router-dom";
import {
    AppBar,
    Badge,
    Box,
    ButtonBase,
    Divider,
    Drawer,
    IconButton,
    Stack,
    styled,
    Toolbar,
    Tooltip,
    useTheme,
} from "@mui/material";

import { Routes } from "config/Routes";
import { useDispatch } from "react-redux";
import { Help, Home, Menu } from "@mui/icons-material";
import logoDark from "#/assets/inode/inode-white.svg";
import logoLight from "#/assets/inode/inode-black.svg";
import { AppDrawer } from "./AppDrawer";
import { push } from "redux-first-history";
import { useAppSelector } from "#store";
import { selectInterpretationIdsFavorited } from "#selectors";
import { Nl2SqlInput } from "#components/commmandLine/Nl2SqlInput";
import { FavoritesCollectionIcon } from "#components/icons/favorites";

const Logo = styled("img")(({ theme }) => ({
    height: `calc(${theme.mixins.toolbar.minHeight}px - ${theme.spacing(1)})`,
}));

const Offset = styled("div")(({ theme }) => {
    return {
        ...theme.mixins.toolbar,
    };
});

export const Header: FC = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    const theme = useTheme();
    const shoppingCartItemsCount = useAppSelector(
        selectInterpretationIdsFavorited
    ).length;

    const [drawerOpen, setDrawerOpen] = React.useState(false);
    const handleDrawerToggle = () => {
        setDrawerOpen(!drawerOpen);
    };

    return (
        <Box sx={{ flexGrow: 1 }}>
            <AppBar
                position="fixed"
                color={"inherit"}
                sx={
                    {
                        // width: "100vw",
                        // zIndex: (theme: Theme) => theme.zIndex.drawer + 1,
                        // width: `calc(100% - ${AppConfig.drawerWidth}px)`,
                        // marginLeft: AppConfig.drawerWidth
                    }
                }
            >
                <Toolbar>
                    <Tooltip title={"Go back to the home page"}>
                        <IconButton
                            onClick={() => dispatch(push(Routes.root.path))}
                        >
                            <Home />
                        </IconButton>
                    </Tooltip>
                    <Divider orientation={"vertical"} sx={{ flexGrow: 1 }} />
                    {location.pathname === "/" ? (
                        <Tooltip title="What is INODE?">
                            <ButtonBase
                                href="http://inode-project.eu/"
                                target="_blank"
                            >
                                <Logo
                                    src={
                                        theme.palette.mode === "dark"
                                            ? logoDark
                                            : logoLight
                                    }
                                />
                            </ButtonBase>
                        </Tooltip>
                    ) : (
                        <Box
                            sx={{
                                flexGrow: 3,
                            }}
                        >
                            <Nl2SqlInput fullWidth={true} />
                        </Box>
                    )}
                    <Divider orientation={"vertical"} sx={{ flexGrow: 1 }} />
                    <Stack direction={"row"} spacing={2}>
                        <Tooltip title="Go to Data Library">
                            <IconButton
                                onClick={() =>
                                    dispatch(push(Routes.dataLibrary.path))
                                }
                            >
                                <Badge
                                    badgeContent={shoppingCartItemsCount}
                                    color="primary"
                                >
                                    <FavoritesCollectionIcon />
                                </Badge>
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Help">
                            <IconButton
                                onClick={() => dispatch(push(Routes.help.path))}
                            >
                                <Help />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Navigation">
                            <IconButton
                                color="inherit"
                                aria-label="open drawer"
                                edge="start"
                                onClick={handleDrawerToggle}
                                sx={{
                                    marginRight: theme => theme.spacing(2),
                                }}
                            >
                                <Menu />
                            </IconButton>
                        </Tooltip>
                    </Stack>
                </Toolbar>
            </AppBar>
            <Offset />
            <nav aria-label="application links">
                <Drawer
                    variant="temporary"
                    anchor={theme.direction === "rtl" ? "left" : "right"}
                    open={drawerOpen}
                    onClose={handleDrawerToggle}
                    ModalProps={{
                        keepMounted: true, // Better open performance on mobile.
                    }}
                >
                    <AppDrawer
                        onClick={() => {
                            setDrawerOpen(false);
                        }}
                    />
                </Drawer>
            </nav>
        </Box>
    );
};
